var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningFeatured(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F6CA76"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 28,
    cy: 28,
    r: 20,
    fill: "#F2B43D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 16)",
    fill: "#F2B43D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.49 16.6886C22.7896 15.4512 22.1126 14.2045 21.4215 12.9671C19.3809 9.29223 17.3404 5.6127 15.2905 1.94251C14.5761 0.663086 13.4601 -0.00464513 11.9939 2.43226e-05C10.509 0.00469377 9.40232 0.705111 8.68323 2.00322C5.96094 6.8968 3.23865 11.7904 0.5257 16.6933C-0.202734 18.0054 -0.179387 19.3315 0.628427 20.6016C1.36153 21.755 2.45885 22.3153 3.82233 22.32C6.54929 22.3293 9.28092 22.32 12.0079 22.32C14.7115 22.32 17.4151 22.32 20.1234 22.32C20.665 22.32 21.188 22.2406 21.6876 22.0352C23.6348 21.2367 24.6901 18.7992 23.4947 16.6933L23.49 16.6886ZM20.5903 19.7658C20.4129 19.8172 20.2308 19.8125 20.0533 19.8125C17.3637 19.8125 14.6788 19.8125 11.9892 19.8125C9.27625 19.8125 6.5633 19.8125 3.85502 19.8125C3.16394 19.8125 2.70633 19.4576 2.54757 18.8179C2.46352 18.4677 2.57092 18.1548 2.73902 17.8513C3.50481 16.4738 4.2706 15.0964 5.03639 13.7189C6.97888 10.2214 8.92137 6.72403 10.8639 3.22661C11.2187 2.5869 11.8258 2.34409 12.4701 2.58223C12.783 2.69897 12.9838 2.93244 13.1379 3.21261C14.0111 4.79088 14.8889 6.36448 15.7668 7.94276C17.6019 11.2487 19.4323 14.5547 21.2814 17.8513C21.7624 18.7105 21.2954 19.5603 20.5903 19.7611V19.7658Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2639 8.65719C13.2639 8.48442 13.2406 8.31165 13.1799 8.14822C12.9651 7.58322 12.3861 7.24702 11.8117 7.34508C11.2094 7.45247 10.7705 7.9381 10.7611 8.55446C10.7471 9.18951 10.7611 9.82455 10.7611 10.4643C10.7611 11.062 10.7611 11.6596 10.7611 12.2527C10.7658 13.0185 11.3121 13.5881 12.0219 13.5788C12.7223 13.5741 13.2639 13.0044 13.2686 12.2573C13.2686 11.0573 13.2686 9.85257 13.2686 8.65252L13.2639 8.65719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0032 14.8209C11.3215 14.8209 10.7612 15.3812 10.7565 16.0629C10.7565 16.7587 11.3122 17.319 12.0126 17.319C12.6943 17.319 13.2593 16.7633 13.264 16.0816C13.2733 15.3952 12.6943 14.8209 12.0079 14.8209H12.0032Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFeatured);
export default __webpack_public_path__ + "static/media/warning-featured.6aa9b80ae4dcfb1be1d37e16793e690c.svg";
export { ForwardRef as ReactComponent };